const autoNgTemplateLoaderTemplate1 = require('./recipes.template.html');

'use strict';

(function () {
    angular
        .module('app.recipes', [])
        .config(recipesConfig);

    recipesConfig.$inject = ['$routeProvider'];

    function recipesConfig($routeProvider) {
        $routeProvider
            .when('/recipes', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'RecipesController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                }
            })
    }
})();
